// extracted by mini-css-extract-plugin
export var fadeInOut = "_3l-3";
export var icon = "_3l-4";
export var savedIndicator = "_3l-2";
export var savingIndicator = "_3l-0";
export var spin = "_3l-1";